import React, { createContext, useState, useEffect } from 'react';
import { withApi } from 'src/wrappers';
import { endPoints } from 'src/constantes';

const PermisosContext = createContext({
  permisos: [],
  puede:    () => false,
  cargando: true,
});

function PermisosProviderBase({ children, doGet }) {
  const [permisos, setPermisos] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      try {
        const { username } = await doGet({ url: endPoints.user.base });
        if (!username) return;

        const usuarioData = await doGet({
          url:  endPoints.seguridad.usuario.find,
          data: { username },
        });

        const rol = usuarioData?.attr?.rol;
        if (!rol) return;

        const rolData = await doGet({
          url:  endPoints.seguridad.rol.find,
          data: { value: rol },
        });

        const permisosDelRol = (rolData?.attr?.permisos || []).map(p => p.nombre);
        setPermisos(permisosDelRol);
      } catch (_) {
        setPermisos([]);
      } finally {
        setCargando(false);
      }
    };

    cargar();
    // eslint-disable-next-line
  }, []);

  const puede = (permiso) => permisos.includes(permiso);

  return (
    <PermisosContext.Provider value={{ permisos, puede, cargando }}>
      {children}
    </PermisosContext.Provider>
  );
}

export const PermisosProvider = withApi(PermisosProviderBase);

export default PermisosContext;
